// Ders (subject) kayıt defteri — tek doğruluk kaynağı.
// Hem çok dersli KonuDagilimi panelini hem App.js filtre/grup görünümlerini besler.
//
// Ders AİLESİ (matematik, kimya, …) ≠ ders DEĞERİ (tyt_matematik, ayt_kimya, …).
// Müfredat ağacı ders ailesi bazındadır (9-12. sınıf tek ağaç); TYT/AYT ayrımı
// sınıftan türer, ayrı aile değildir.

// LGS ders değerleri (DB ENUM). Ana liste filtresine (DERSLER) GİRMEZ: LGS soruları
// v_sorular_birlesik'te yok; etiket yalnız dersLabel ve LGS ailesi için.
export const LGS_DERSLERI = [
  { value: 'lgs_turkce', label: 'LGS Türkçe' },
  { value: 'lgs_matematik', label: 'LGS Matematik' },
  { value: 'lgs_fen', label: 'LGS Fen Bilimleri' },
  { value: 'lgs_inkilap', label: 'LGS T.C. İnkılap Tarihi ve Atatürkçülük' },
  { value: 'lgs_din', label: 'LGS Din Kültürü' },
  { value: 'lgs_ingilizce', label: 'LGS İngilizce' },
];

// Aktif aileler veri/müfredata sahip; pasifler "yakında" rozetiyle görünür.
export const DERS_AILELERI = [
  {
    key: 'matematik',
    label: 'Matematik',
    kisaAd: 'Mat',
    ikon: '📐',
    renk: '#2563EB',
    mufredatDers: 'matematik',           // GET /api/kazanim?ders=matematik
    dersDegerleri: ['tyt_matematik', 'ayt_matematik', 'tyt_geometri', 'ayt_geometri'],
    aktif: true,
  },
  {
    key: 'kimya',
    label: 'Kimya',
    kisaAd: 'Kim',
    ikon: '🧪',
    renk: '#EC4899',
    mufredatDers: 'kimya',               // GET /api/kazanim?ders=kimya
    dersDegerleri: ['tyt_kimya', 'ayt_kimya'],
    aktif: true,
  },
  {
    key: 'fizik',
    label: 'Fizik',
    kisaAd: 'Fiz',
    ikon: '⚛️',
    renk: '#EA580C',
    mufredatDers: 'fizik',
    dersDegerleri: ['tyt_fizik', 'ayt_fizik'],
    aktif: true,
  },
  {
    key: 'biyoloji',
    label: 'Biyoloji',
    kisaAd: 'Biy',
    ikon: '🧬',
    renk: '#9333EA',
    mufredatDers: 'biyoloji',
    dersDegerleri: ['tyt_biyoloji', 'ayt_biyoloji'],
    aktif: true,
  },
  {
    key: 'turkce',
    label: 'Türkçe',
    kisaAd: 'Tür',
    ikon: '📖',
    renk: '#0D9488',
    mufredatDers: 'turkce',
    dersDegerleri: ['tyt_turkce', 'ayt_edebiyat'],
    aktif: true,
  },
  {
    key: 'sosyal',
    label: 'Sosyal',
    kisaAd: 'Sos',
    ikon: '🌍',
    renk: '#CA8A04',
    mufredatDers: 'sosyal',
    // 2026-07-17 bölme: 11 gerçek alt-ders (+ legacy tyt_sosyal/ayt_sosyal, birleşik toplam güvenliği)
    dersDegerleri: ['tyt_tarih', 'tyt_cografya', 'tyt_felsefe', 'tyt_din',
      'ayt_tarih', 'ayt_cografya', 'ayt_felsefe', 'ayt_mantik', 'ayt_psikoloji', 'ayt_sosyoloji', 'ayt_din',
      'tyt_sosyal', 'ayt_sosyal'],
    aktif: true, // 2026-07-14 Sosyal-Maarif pilotu (Felsefe #14069-14076)
  },
  {
    // LGS (8. sınıf, 4 şık): izole `sorular_lgs` tablosu; pilot Matematik (2026-10-19).
    key: 'lgs',
    label: 'LGS',
    kisaAd: 'LGS',
    ikon: '🎒',
    renk: '#DB2777',
    dersDegerleri: LGS_DERSLERI.map((d) => d.value),
    aktif: true,
  },
];

// Ders DEĞERİ → kesin renk (liste/grup görünümündeki mevcut paleti korur).
export const DERS_RENK = {
  tyt_matematik: '#2196F3', ayt_matematik: '#1565C0',
  tyt_geometri: '#4CAF50', ayt_geometri: '#2E7D32',
  tyt_fizik: '#FF9800', ayt_fizik: '#E65100',
  tyt_biyoloji: '#9C27B0', ayt_biyoloji: '#6A1B9A',
  tyt_kimya: '#EC4899', ayt_kimya: '#BE185D', // kırmızı YALNIZ 1 puan rozetinde
  tyt_turkce: '#0D9488', ayt_edebiyat: '#0F766E',
  tyt_sosyal: '#CA8A04', ayt_sosyal: '#A16207', // legacy (2026-07-17 bölme öncesi)
  // Sosyal alt-dersleri (2026-07-17 bölme) — alt-ders başına ayırt edici renk (TYT açık / AYT koyu)
  tyt_tarih: '#CA8A04', ayt_tarih: '#A16207',
  tyt_cografya: '#16A34A', ayt_cografya: '#15803D',
  tyt_felsefe: '#7C3AED', ayt_felsefe: '#6D28D9',
  tyt_din: '#0891B2', ayt_din: '#0E7490',
  ayt_mantik: '#795548', ayt_psikoloji: '#A21CAF', ayt_sosyoloji: '#65A30D',
  // LGS (2026-10-20): YKS karşılığının tonu; liste kartları gri kalmasın.
  lgs_turkce: '#0D9488', lgs_matematik: '#2196F3', lgs_fen: '#FF9800',
  lgs_inkilap: '#CA8A04', lgs_din: '#0891B2', lgs_ingilizce: '#4F46E5',
};

export function dersRenk(ders) {
  return DERS_RENK[ders] || '#757575';
}

// App.js filtre dropdown'u için {value,label} listesi (geriye uyum).
export const DERSLER = [
  { value: '', label: 'Tüm Dersler' },
  { value: 'tyt_matematik', label: 'TYT Matematik' },
  { value: 'ayt_matematik', label: 'AYT Matematik' },
  { value: 'tyt_geometri', label: 'TYT Geometri' },
  { value: 'ayt_geometri', label: 'AYT Geometri' },
  { value: 'tyt_fizik', label: 'TYT Fizik' },
  { value: 'ayt_fizik', label: 'AYT Fizik' },
  { value: 'tyt_kimya', label: 'TYT Kimya' },
  { value: 'ayt_kimya', label: 'AYT Kimya' },
  { value: 'tyt_biyoloji', label: 'TYT Biyoloji' },
  { value: 'ayt_biyoloji', label: 'AYT Biyoloji' },
  { value: 'tyt_turkce', label: 'TYT Türkçe' },
  { value: 'ayt_edebiyat', label: 'AYT Edebiyat' },
  // Sosyal alt-dersleri (2026-07-17 bölme) — gerçek ders değerleri (tyt_sosyal/ayt_sosyal artık legacy)
  { value: 'tyt_tarih', label: 'TYT Tarih' },
  { value: 'tyt_cografya', label: 'TYT Coğrafya' },
  { value: 'tyt_felsefe', label: 'TYT Felsefe' },
  { value: 'tyt_din', label: 'TYT Din Kültürü' },
  { value: 'ayt_tarih', label: 'AYT Tarih' },
  { value: 'ayt_cografya', label: 'AYT Coğrafya' },
  { value: 'ayt_felsefe', label: 'AYT Felsefe' },
  { value: 'ayt_mantik', label: 'AYT Mantık' },
  { value: 'ayt_psikoloji', label: 'AYT Psikoloji' },
  { value: 'ayt_sosyoloji', label: 'AYT Sosyoloji' },
  { value: 'ayt_din', label: 'AYT Din Kültürü' },
];

// Ders değeri → okunabilir Türkçe etiket ('tyt_turkce' → 'TYT Türkçe').
export function dersLabel(ders) {
  return [...DERSLER, ...LGS_DERSLERI].find((d) => d.value === ders)?.label || (ders || '').replace('_', ' ');
}

// ── Sınav-bazlı ders pilleri (2026-07-17 panel ergonomi) ─────────────────────
// KonuDagilimi'nin TYT/AYT → ders hiyerarşisi için kayıt defteri. Alan adları
// DersPills/aileToplami'nin okuduğu şekille birebir (key/label/ikon/renk/aktif/
// dersDegerleri) → Pills.js değişmeden yeniden kullanılır. Ek alan:
//   kazanimKey — GET /api/kazanim?ders=<kazanimKey> fetch anahtarı. Aile adı
//   (matematik/kimya/...) veya sosyal alt-ders değeri (tyt_tarih — backend
//   sosyalKonuSuz filtreli ağacı döndürür).
//   ogrenmeAlani (ops.) — matematik/geometri AYNI kazanım ağacını paylaşır
//   (geometri MEB haritasında ayrı `ders` değil, "GEOMETRİ" öğrenme alanı).
//   2026-07-17 matematik/geometri ayrımı: geometri pili yalnız 'GEOMETRİ' alanını,
//   matematik pili '!GEOMETRİ' (hariç) konularını gösterir (bkz konuAlaninda).
// Legacy tyt_sosyal/ayt_sosyal hiçbir pilde YOK (boş "Tüm Dersler" seçimiyle erişilir).
export const SINAV_DERSLERI = {
  TYT: [
    { key: 'tyt_matematik', label: 'Matematik', ikon: '📐', renk: DERS_RENK.tyt_matematik, aktif: true, kazanimKey: 'matematik', ogrenmeAlani: '!GEOMETRİ', dersDegerleri: ['tyt_matematik'] },
    { key: 'tyt_geometri', label: 'Geometri', ikon: '📏', renk: DERS_RENK.tyt_geometri, aktif: true, kazanimKey: 'matematik', ogrenmeAlani: 'GEOMETRİ', dersDegerleri: ['tyt_geometri'] },
    { key: 'tyt_kimya', label: 'Kimya', ikon: '🧪', renk: DERS_RENK.tyt_kimya, aktif: true, kazanimKey: 'kimya', dersDegerleri: ['tyt_kimya'] },
    { key: 'tyt_fizik', label: 'Fizik', ikon: '⚛️', renk: DERS_RENK.tyt_fizik, aktif: true, kazanimKey: 'fizik', dersDegerleri: ['tyt_fizik'] },
    { key: 'tyt_biyoloji', label: 'Biyoloji', ikon: '🧬', renk: DERS_RENK.tyt_biyoloji, aktif: true, kazanimKey: 'biyoloji', dersDegerleri: ['tyt_biyoloji'] },
    { key: 'tyt_turkce', label: 'Türkçe', ikon: '📖', renk: DERS_RENK.tyt_turkce, aktif: true, kazanimKey: 'turkce', dersDegerleri: ['tyt_turkce'] },
    { key: 'tyt_tarih', label: 'Tarih', ikon: '🏺', renk: DERS_RENK.tyt_tarih, aktif: true, kazanimKey: 'tyt_tarih', dersDegerleri: ['tyt_tarih'] },
    { key: 'tyt_cografya', label: 'Coğrafya', ikon: '🗺️', renk: DERS_RENK.tyt_cografya, aktif: true, kazanimKey: 'tyt_cografya', dersDegerleri: ['tyt_cografya'] },
    { key: 'tyt_felsefe', label: 'Felsefe', ikon: '🦉', renk: DERS_RENK.tyt_felsefe, aktif: true, kazanimKey: 'tyt_felsefe', dersDegerleri: ['tyt_felsefe'] },
    { key: 'tyt_din', label: 'Din', ikon: '🕌', renk: DERS_RENK.tyt_din, aktif: true, kazanimKey: 'tyt_din', dersDegerleri: ['tyt_din'] },
  ],
  AYT: [
    { key: 'ayt_matematik', label: 'Matematik', ikon: '📐', renk: DERS_RENK.ayt_matematik, aktif: true, kazanimKey: 'matematik', ogrenmeAlani: '!GEOMETRİ', dersDegerleri: ['ayt_matematik'] },
    { key: 'ayt_geometri', label: 'Geometri', ikon: '📏', renk: DERS_RENK.ayt_geometri, aktif: true, kazanimKey: 'matematik', ogrenmeAlani: 'GEOMETRİ', dersDegerleri: ['ayt_geometri'] },
    { key: 'ayt_kimya', label: 'Kimya', ikon: '🧪', renk: DERS_RENK.ayt_kimya, aktif: true, kazanimKey: 'kimya', dersDegerleri: ['ayt_kimya'] },
    { key: 'ayt_fizik', label: 'Fizik', ikon: '⚛️', renk: DERS_RENK.ayt_fizik, aktif: true, kazanimKey: 'fizik', dersDegerleri: ['ayt_fizik'] },
    { key: 'ayt_biyoloji', label: 'Biyoloji', ikon: '🧬', renk: DERS_RENK.ayt_biyoloji, aktif: true, kazanimKey: 'biyoloji', dersDegerleri: ['ayt_biyoloji'] },
    { key: 'ayt_edebiyat', label: 'Edebiyat', ikon: '📖', renk: DERS_RENK.ayt_edebiyat, aktif: true, kazanimKey: 'edebiyat', dersDegerleri: ['ayt_edebiyat'] },
    { key: 'ayt_tarih', label: 'Tarih', ikon: '🏺', renk: DERS_RENK.ayt_tarih, aktif: true, kazanimKey: 'ayt_tarih', dersDegerleri: ['ayt_tarih'] },
    { key: 'ayt_cografya', label: 'Coğrafya', ikon: '🗺️', renk: DERS_RENK.ayt_cografya, aktif: true, kazanimKey: 'ayt_cografya', dersDegerleri: ['ayt_cografya'] },
    { key: 'ayt_felsefe', label: 'Felsefe', ikon: '🦉', renk: DERS_RENK.ayt_felsefe, aktif: true, kazanimKey: 'ayt_felsefe', dersDegerleri: ['ayt_felsefe'] },
    { key: 'ayt_mantik', label: 'Mantık', ikon: '🧩', renk: DERS_RENK.ayt_mantik, aktif: true, kazanimKey: 'ayt_mantik', dersDegerleri: ['ayt_mantik'] },
    { key: 'ayt_psikoloji', label: 'Psikoloji', ikon: '🧠', renk: DERS_RENK.ayt_psikoloji, aktif: true, kazanimKey: 'ayt_psikoloji', dersDegerleri: ['ayt_psikoloji'] },
    { key: 'ayt_sosyoloji', label: 'Sosyoloji', ikon: '👥', renk: DERS_RENK.ayt_sosyoloji, aktif: true, kazanimKey: 'ayt_sosyoloji', dersDegerleri: ['ayt_sosyoloji'] },
    { key: 'ayt_din', label: 'Din', ikon: '🕌', renk: DERS_RENK.ayt_din, aktif: true, kazanimKey: 'ayt_din', dersDegerleri: ['ayt_din'] },
  ],
  // LGS (2026-10-20, Basım konu testi): MEB oturum sırası — sözel Türkçe → İnkılap → Din → İngilizce,
  // sayısal Matematik → Fen. Kazanım haritası her ders için ayrı (KONU_KAZANIM_HARITASI_LGS_*).
  LGS: [
    { key: 'lgs_turkce', label: 'Türkçe', ikon: '📖', renk: DERS_RENK.lgs_turkce, aktif: true, kazanimKey: 'lgs_turkce', dersDegerleri: ['lgs_turkce'] },
    { key: 'lgs_inkilap', label: 'İnkılap Tarihi', ikon: '🏺', renk: DERS_RENK.lgs_inkilap, aktif: true, kazanimKey: 'lgs_inkilap', dersDegerleri: ['lgs_inkilap'] },
    { key: 'lgs_din', label: 'Din', ikon: '🕌', renk: DERS_RENK.lgs_din, aktif: true, kazanimKey: 'lgs_din', dersDegerleri: ['lgs_din'] },
    { key: 'lgs_ingilizce', label: 'İngilizce', ikon: '🇬🇧', renk: DERS_RENK.lgs_ingilizce, aktif: true, kazanimKey: 'lgs_ingilizce', dersDegerleri: ['lgs_ingilizce'] },
    { key: 'lgs_matematik', label: 'Matematik', ikon: '📐', renk: DERS_RENK.lgs_matematik, aktif: true, kazanimKey: 'lgs_matematik', dersDegerleri: ['lgs_matematik'] },
    { key: 'lgs_fen', label: 'Fen Bilimleri', ikon: '🔬', renk: DERS_RENK.lgs_fen, aktif: true, kazanimKey: 'lgs_fen', dersDegerleri: ['lgs_fen'] },
  ],
};

// Şık harfleri: LGS 4 şık (A–D), YKS 5 şık. Argüman ders ('lgs_fen') ya da sınav ('LGS', 'LGS_SOZEL').
export function sikHarfleri(dersVeyaSinav) {
  return /^lgs/i.test(String(dersVeyaSinav || '')) ? ['A', 'B', 'C', 'D'] : ['A', 'B', 'C', 'D', 'E'];
}

// Bir konu verilen sınava (TYT/AYT) ait mi? Haritaların çoğu konu-seviyesi
// `sinav_tipi` taşır (kimya/fizik/biyoloji/türkçe/sosyal/Maarif); yalnız MEB
// matematik haritasında bu alan yok → sınıftan türetilir (9-10=TYT, 11-12=AYT).
export function konuSinavda(konu, sinav) {
  if (konu.sinav_tipi) return konu.sinav_tipi === sinav;
  const s = Number(konu.sinif);
  return sinav === 'TYT' ? (s === 9 || s === 10) : (s === 11 || s === 12);
}

// ── Müfredat kayıt defteri (2026-09-03) ─────────────────────────────────────
// Kazanım ağacı (KonuDagilimi) ve filtre barındaki müfredat toggle'ı aynı dili
// konuşsun diye tek yerde. `v` backend'in beklediği değer (?mufredat=…);
// MEB_2018 parametresiz çağrıya denk gelir (backend varsayılanı).
export const MUFREDATLAR = [
  { v: 'MEB_2018', kisa: '2018', ad: 'MEB 2018', yks: '2026-2027 YKS', renk: '#1D4ED8' },
  { v: 'Maarif_2024', kisa: 'Maarif', ad: 'Maarif 2024', yks: '2028 ve sonrası', renk: '#7C3AED' },
];

export function mufredatBilgi(v) {
  return MUFREDATLAR.find((m) => m.v === v) || MUFREDATLAR[0];
}

// Maarif matematik haritasında geometri ne ayrı bir `ders` ne de 'GEOMETRİ'
// öğrenme alanıdır — temalar kendi adlarıyla ayrışır (Geometrik Şekiller,
// Eşlik ve Benzerlik, Geometrik Cisimler, Analitik İnceleme). Bu yüzden
// MEB'in '!GEOMETRİ' alan kuralı Maarif ağacında hiçbir konuyu elemiyor,
// geometri pili de boş kalıyordu (ölçüm: sorular_maarif'te tyt_geometri 1127,
// ayt_geometri 568 soru — hepsi MAT.* kodlu).
// Liste harita alan ADLARINDAN değil üretim routine'lerinden türer:
// /core-maarif-geometri-routine → MAT.9.3/9.4/12.3/10.1/10.6 (TYT),
// /core-maarif-ayt-geometri-routine → MAT.11.2/12.2 (AYT). Harita yeniden
// üretilip alan adı değişse de ayrım bozulmaz.
export const MAARIF_GEOMETRI_KONULARI = new Set([
  'MAT.9.3', 'MAT.9.4', 'MAT.12.3', 'MAT.10.1', 'MAT.10.6', 'MAT.11.2', 'MAT.12.2',
]);

// Bir konu, pilin öğrenme-alanı kuralına uyuyor mu? (matematik/geometri ayrımı)
//   kural yok → true (tüm dersler)
//   'GEOMETRİ'  → yalnız o alan (geometri pili)
//   '!GEOMETRİ' → o alan HARİÇ (matematik pili)
// mufredat='Maarif_2024' iken geometri kuralı alan adı yerine konu koduna bakar
// (bkz MAARIF_GEOMETRI_KONULARI). Parametre verilmezse eski davranış birebir.
export function konuAlaninda(konu, alanKurali, mufredat) {
  if (!alanKurali) return true;
  if (mufredat === 'Maarif_2024' && (alanKurali === 'GEOMETRİ' || alanKurali === '!GEOMETRİ')) {
    const geo = MAARIF_GEOMETRI_KONULARI.has(konu.kod);
    return alanKurali.startsWith('!') ? !geo : geo;
  }
  const alan = (konu.ogrenme_alani || '').trim();
  return alanKurali.startsWith('!') ? alan !== alanKurali.slice(1) : alan === alanKurali;
}

// Ders değeri → ÖSYM kitapçık başlığı. AYNA — TEK DOĞRU KAYNAK:
// backend/src/lib/dersBaslik.js (PDF'i fiilen o üretir). CRA'nın
// ModuleScopePlugin'i src/ dışına import ettirmediği için fiziksel tek dosya
// kullanılamıyor; iki kopya tests/test_ders_baslik_senkron.js ile kilitli.
//
// 2026-08-13 düzeltmesi (öğretmen bulgusu): eski `includes()` zinciri
// GEOMETRİYİ TANIMIYORDU (tyt_geometri/ayt_geometri → 'TEMEL MATEMATIK'),
// ayrıca ÖSYM'de bulunmayan adlar üretiyordu: 'TEMEL EDEBİYAT' (ÖSYM: Türk
// Dili ve Edebiyatı), 'TEMEL TÜRKÇE' (ÖSYM: Türkçe), AYT'de 'TEMEL ...'
// ("Temel" ön eki yalnız TYT Temel Matematik'te vardır).
//
// CAPS değerleri ELLE yazılır: JS'in varsayılan locale'inde 'i'.toUpperCase()
// 'I' verir, ÖSYM 'İ' kullanır.
export const DERS_BASLIK = {
  tyt_matematik: { ad: 'Temel Matematik', adCaps: 'TEMEL MATEMATİK' },
  tyt_geometri: { ad: 'Geometri', adCaps: 'GEOMETRİ' },
  tyt_fizik: { ad: 'Fizik', adCaps: 'FİZİK' },
  tyt_kimya: { ad: 'Kimya', adCaps: 'KİMYA' },
  tyt_biyoloji: { ad: 'Biyoloji', adCaps: 'BİYOLOJİ' },
  tyt_turkce: { ad: 'Türkçe', adCaps: 'TÜRKÇE' },
  tyt_sosyal: { ad: 'Sosyal Bilimler', adCaps: 'SOSYAL BİLİMLER' },
  tyt_tarih: { ad: 'Tarih', adCaps: 'TARİH' },
  tyt_cografya: { ad: 'Coğrafya', adCaps: 'COĞRAFYA' },
  tyt_felsefe: { ad: 'Felsefe', adCaps: 'FELSEFE' },
  tyt_din: { ad: 'Din Kültürü ve Ahlak Bilgisi', adCaps: 'DİN KÜLTÜRÜ VE AHLAK BİLGİSİ' },
  ayt_matematik: { ad: 'Matematik', adCaps: 'MATEMATİK' },
  ayt_geometri: { ad: 'Geometri', adCaps: 'GEOMETRİ' },
  ayt_fizik: { ad: 'Fizik', adCaps: 'FİZİK' },
  ayt_kimya: { ad: 'Kimya', adCaps: 'KİMYA' },
  ayt_biyoloji: { ad: 'Biyoloji', adCaps: 'BİYOLOJİ' },
  ayt_edebiyat: { ad: 'Türk Dili ve Edebiyatı', adCaps: 'TÜRK DİLİ VE EDEBİYATI' },
  ayt_sosyal: { ad: 'Sosyal Bilimler', adCaps: 'SOSYAL BİLİMLER' },
  ayt_tarih: { ad: 'Tarih', adCaps: 'TARİH' },
  ayt_cografya: { ad: 'Coğrafya', adCaps: 'COĞRAFYA' },
  ayt_felsefe: { ad: 'Felsefe', adCaps: 'FELSEFE' },
  ayt_mantik: { ad: 'Mantık', adCaps: 'MANTIK' },
  ayt_psikoloji: { ad: 'Psikoloji', adCaps: 'PSİKOLOJİ' },
  ayt_sosyoloji: { ad: 'Sosyoloji', adCaps: 'SOSYOLOJİ' },
  ayt_din: { ad: 'Din Kültürü ve Ahlak Bilgisi', adCaps: 'DİN KÜLTÜRÜ VE AHLAK BİLGİSİ' },
  // --- LGS (2026-10-19; MEB 8. sınıf, 4 şık; sinavTuru -> 'LGS') ---
  lgs_turkce: { ad: 'Türkçe', adCaps: 'TÜRKÇE' },
  lgs_matematik: { ad: 'Matematik', adCaps: 'MATEMATİK' },
  lgs_fen: { ad: 'Fen Bilimleri', adCaps: 'FEN BİLİMLERİ' },
  lgs_inkilap: { ad: 'T.C. İnkılap Tarihi ve Atatürkçülük', adCaps: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK' },
  lgs_din: { ad: 'Din Kültürü ve Ahlak Bilgisi', adCaps: 'DİN KÜLTÜRÜ VE AHLAK BİLGİSİ' },
  lgs_ingilizce: { ad: 'İngilizce', adCaps: 'İNGİLİZCE' },
};

// Boş/bilinmeyen ders (ör. "Tüm Dersler") matematik+geometriye döner — Basım'da
// ders boşken sorgu zaten yalnız matematik+geometriyi kapsar.
export function dersBaslik(ders) {
  const b = DERS_BASLIK[ders];
  return b ? b.adCaps : DERS_BASLIK.tyt_matematik.adCaps;
}

// Ders-bazlı yetki (2026-06-21): kısıtlı kullanıcının dropdown'da göreceği dersler.
// izinliDersler null/boş = kısıtsız → tüm DERSLER. Dolu dizi = '' (Tüm Derslerim,
// backend zaten süzer) + yalnız izinli ders değerleri.
export function gorunurDersler(izinliDersler) {
  if (!Array.isArray(izinliDersler) || izinliDersler.length === 0) return DERSLER;
  const izin = new Set(izinliDersler);
  return DERSLER.filter((d) => d.value === '' || izin.has(d.value)).map((d) =>
    d.value === '' ? { value: '', label: 'Tüm Derslerim' } : d
  );
}

// hex → rgba (yumuşak dolgu/çerçeve tonları için).
export function hexToRgba(hex, alpha = 1) {
  const h = (hex || '').replace('#', '');
  if (h.length !== 6) return hex;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Bir ders ailesinin tüm ders değerleri üzerinden toplam soru sayısı.
// sayilarMap: { tyt_matematik: N, ayt_kimya: M, ... } (GET /api/kazanim/ders-ozeti)
export function aileToplami(aile, sayilarMap) {
  if (!sayilarMap) return 0;
  return aile.dersDegerleri.reduce((acc, dv) => acc + (sayilarMap[dv] || 0), 0);
}

// Bir ders DEĞERİ için Maarif_2024 verisi var mı? (2026-07-08 — Maarif rozeti/
// filtresi yalnız matematik'e sabitliydi; artık veri-güdümlü: hangi ders
// değerinde gerçekten Maarif satırı varsa orada gösterilir.)
// maarifSayilar: GET /api/kazanim/ders-ozeti → `maarif` nesnesi
// ({ tyt_matematik: a, tyt_kimya: b, tyt_biyoloji: c, tyt_fizik: d, ... }).
export function dersMaarifVarMi(ders, maarifSayilar) {
  return !!(ders && maarifSayilar && (maarifSayilar[ders] || 0) > 0);
}

// Ders HEM MEB_2018 HEM Maarif_2024 verisi taşıyor mu? Müfredat seçici (Hepsi/
// 2018/Maarif) yalnız bu durumda anlamlı — 2026-07-17:
//  · Maarif yok (ör. AYT Kimya, mSayi=0) → seçici zaten gizliydi (dersMaarifVarMi).
//  · MEB yok (SOSYAL: tek müfredat, hepsi=mSayi → meb=0) → seçici gösterilirse
//    "2018 0" rozeti çıkar ama tıklanınca liste Maarif sorularını gösterirdi
//    (backend sosyali her müfredatta izole Maarif tablosuna yönlendiriyordu).
//    Backend artık sosyal+MEB_2018'e boş küme döner; seçiciyi de gizleyip
//    kullanıcıya anlamsız bir "0" butonu sunmuyoruz. Simetrik ve veri-güdümlü.
export function dersCiftMufredatliMi(ders, dersOzeti, maarifSayilar) {
  const maarif = (ders && maarifSayilar && maarifSayilar[ders]) || 0;
  const hepsi = (ders && dersOzeti && dersOzeti[ders]) || 0;
  return maarif > 0 && (hepsi - maarif) > 0;
}

// Maarif_2024 kazanım kod önekleri — kod-string sezgisi için (yalnız backend
// `mufredat_efektif` alanı YOKSA devreye girer, bkz maarifKazanimMi altındaki not).
// BIY. BİLİNÇLİ OLARAK BURADA YOK — MEB_2018 biyoloji "BIY.<ünite 1-12>.<konu>.<alt>"
// da Maarif biyoloji "BIY.<sinif 9|10>.<tema>.<konu>" ile AYNI segment-sayısını
// kullanıyor (FIZ.'in aksine, 4-vs-3 ayrımı burada yok — segment-sayısına duyarlı
// güvenli bir regex YAZILAMAZ). Bu yüzden BIY. için sezgi "belirsizse Maarif SAY"
// yerine "belirsizse Maarif SAYMA" (false) tercih edilir — yanlış rozet göstermek
// (orijinal bug, 54 soru) hiç göstermemekten daha kötü bir sonuçtur.
// TDE. / TDE10. / TDE11. (Türk Dili ve Edebiyatı, Maarif) — 2026-10-09 kullanıcı kararı:
// Türkçe-Maarif TDM. → TDE., Edebiyat EDB. → TDE10. (10. sınıf), EDB11. → TDE11.
// MEB_2018 Türkçe "TR." kullanır, hiçbir MEB dersi "TDE" kullanmaz → düz startsWith
// güvenli; önekler noktayla ayrılır ('TDE.' ≠ 'TDE10.').
// TAR./COG./FEL./DKAB. (Sosyal-Maarif) — 2026-07-14 pilotu. Sosyal'in MEB_2018
// tablosu/kodu hiç yok (tek müfredat) → dört önek de benzersiz, düz startsWith güvenli.
export const MAARIF_KAZANIM_ONEKLERI = ['MAT.', 'GEO.', 'KIM.', 'TDE.', 'TDE10.', 'TDE11.', 'TAR.', 'COG.', 'FEL.', 'DKAB.', 'MAN.', 'PSK.', 'SOS.', 'ITA.'];

// 2026-07-08 — FIZ. çakışma notu: MEB_2018 fizik de "FIZ." önekini kullanır
// (FIZ.<sinif>.<unite>.<konu>.<kazanim>, DAİMA 4 sayısal segment — 213/213
// kazanim_fizik satırı doğrulandı), Maarif fizik ise FIZ.<sinif>.<unite>.<konu>
// (3 sayısal segment). Düz .startsWith('FIZ.') MEB_2018 fizik sorularının
// (357 soru sinif 9-10'da) YANLIŞLIKLA Maarif rozeti almasına yol açar — bu
// yüzden FIZ. düz önek listesine EKLENMEDİ; ayrı, segment-sayısına duyarlı bir
// regex ile kontrol edilir (aşağıda). BIY.'nin aksine burada segment-sayısı
// (4 vs 3) MEB'i Maarif'ten güvenle ayırt etmeye yeter.
// 2026-09-13: 11. sınıf (AYT) Maarif fizik kodları da 3 sayısal segment (FIZ.11.1.10).
const MAARIF_FIZIK_KOD_RE = /^FIZ\.(9|10|11|12)\.\d+\.\d+$/;
// Kimya/matematik/geometri MEB kodları saf sayısal (ör. "9.3.2") — "MEB 2018"
// rozeti bu kalıba bakarak gösterilir (BIY./FIZ. gibi harf-önekli MEB kodları
// bu regex'e uymaz, onlar icin mufredat_efektif kullanilir, asagida).
const MEB_NUMERIK_KOD_RE = /^\d+\.\d+/;

// 2026-07-08 — GERÇEK KAYNAK SİNYALİ (backend'den `mufredat_efektif`):
// GET /api/sorular ve GET /api/sorular/:id artık her satıra hangi fiziksel
// tablodan geldiğine göre hesaplanmış `mufredat_efektif` ('MEB_2018' |
// 'Maarif_2024') ekliyor (bkz backend/src/routes/sorular.js — tablo adı
// `_maarif` ile bitiyorsa Maarif_2024, `v_sorular_birlesik` sorgularında
// per-satır `_kaynak_tablo`dan türetiliyor). Bu, kazanim_kodu STRING
// TAHMİNİNDEN çok daha güvenilir — BIY. ve FIZ. gibi MEB_2018 ile Maarif_2024
// arasında AYNI önek+segment-sayısını paylaşan derslerde kod-string'i
// yapısal olarak ayrıştırılamaz (ünite 9/10 olan MEB biyoloji soruları bu
// yüzden eskiden FIZ. sorunuyla aynı şekilde yanlış "Maarif" rozeti alıyordu
// — 54 soru, bkz canlı DB doğrulaması). `mufredat_efektif` mevcutsa TEK
// doğruluk kaynağıdır ve canlı çağrı yollarının TAMAMINDA doludur (regresyon
// testiyle doğrulandı: 300/300 satır dolu); yalnız bu alanı taşımayan
// hipotetik eski/önbelleklenmiş veri için savunmacı bir kod-string sezgisine
// düşülür (BIY. için bilinçli olarak "false" — yukarı bak).
export function maarifKazanimMi(kod, mufredatEfektif) {
  if (mufredatEfektif) return mufredatEfektif === 'Maarif_2024';
  if (!kod) return false;
  if (kod.startsWith('FIZ.')) return MAARIF_FIZIK_KOD_RE.test(kod);
  if (kod.startsWith('BIY.')) return false;
  return MAARIF_KAZANIM_ONEKLERI.some((onek) => kod.startsWith(onek));
}

// maarifKazanimMi'nin aynası — "MEB 2018" rozetini de artık gerçek sinyale göre
// göstermek için (önceden yalnız saf-sayısal kod regex'ine bakıyordu, BIY./FIZ.
// gibi harf-önekli MEB kodlarında rozet hiç görünmüyordu).
export function mebKazanimMi(kod, mufredatEfektif) {
  if (mufredatEfektif) return mufredatEfektif === 'MEB_2018';
  if (!kod) return false;
  return MEB_NUMERIK_KOD_RE.test(kod);
}

// Soru kartindaki `kazanim_adi` (backend kazanimAdi) etiketi (2026-10-08):
// MEB 2018 "Kazanım", Maarif 2024 "Öğrenme çıktısı".
export function kazanimEtiketi(s) {
  return maarifKazanimMi(s.kazanim_kodu, s.mufredat_efektif) ? 'Öğrenme çıktısı' : 'Kazanım';
}

// Müfredat seçimine bağlı metinler (basım, liste süzgeci, kazanım ağacı; 2026-10-09 kullanıcı
// kararı): Maarif 2024 seçiliyken "öğrenme çıktısı", MEB 2018 ve "Hepsi"de "kazanım". Ek
// değiştiği için çekimler ayrı tutulur ("kazanımı" belirtme = "öğrenme çıktısını"; birleşik
// adda iyelikli ve iyeliksiz çoğul aynı: "alt kazanımları" / "dersin kazanımlarını").
const _SOZ_MAARIF = {
  ad: 'öğrenme çıktısı', Ad: 'Öğrenme çıktısı', adi: 'öğrenme çıktısını',
  adda: 'öğrenme çıktısında', adin: 'öğrenme çıktısının',
  adlar: 'öğrenme çıktıları', Adlar: 'Öğrenme çıktıları',
  adlari: 'öğrenme çıktılarını', adlarini: 'öğrenme çıktılarını',
  adlardan: 'öğrenme çıktılarından', adlarindan: 'öğrenme çıktılarından',
};
const _SOZ_MEB = {
  ad: 'kazanım', Ad: 'Kazanım', adi: 'kazanımı',
  adda: 'kazanımda', adin: 'kazanımın',
  adlar: 'kazanımlar', Adlar: 'Kazanımlar',
  adlari: 'kazanımları', adlarini: 'kazanımlarını',
  adlardan: 'kazanımlardan', adlarindan: 'kazanımlarından',
};
export function kazanimSozleri(mufredat) {
  return mufredat === 'Maarif_2024' ? _SOZ_MAARIF : _SOZ_MEB;
}

// Kart basligi (2026-10-09): Maarif'te "Tema › bolum" (tema_adi backend'den; bolum =
// ayirt edici alt_konu, yoksa konu — #41753 "Enerji" tema sanildi). MEB'de konu.
export function kartBasligi(s) {
  const maarif = maarifKazanimMi(s.kazanim_kodu, s.mufredat_efektif);
  const bolum = (maarif && s.alt_konu) || s.konu || '';
  if (!maarif || !s.tema_adi) return bolum;
  if (!bolum || s.tema_adi.toLocaleLowerCase('tr') === bolum.toLocaleLowerCase('tr')) return s.tema_adi;
  return `${s.tema_adi} › ${bolum}`;
}
